import { render } from "./BannerOutrasSolucoes.vue?vue&type=template&id=1140101b&scoped=true"
import script from "./BannerOutrasSolucoes.vue?vue&type=script&lang=js"
export * from "./BannerOutrasSolucoes.vue?vue&type=script&lang=js"

import "./BannerOutrasSolucoes.vue?vue&type=style&index=0&id=1140101b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1140101b"]])

export default __exports__